import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';
import { FaWhatsapp, FaEye } from 'react-icons/fa';
import { destinos } from '../data/destinos';
import ImageWithFallback from './ImageWithFallback';

export default function Destinos() {
  const navigate = useNavigate();
  // Obtener los destinos más populares (primeros 8)
  const destinosPopulares = destinos.slice(0, 8);

  // Función para generar mensaje de WhatsApp
  const generarMensajeWhatsApp = (destino) => {
    const mensaje = `Hola Belu Tours! Me interesa conocer más sobre el destino ${destino.ciudad}, ${destino.pais}. ¿Podrían brindarme información sobre precios, fechas disponibles y servicios incluidos?`;
    return encodeURIComponent(mensaje);
  };

  // Función para verificar si el destino tiene información detallada
  const tieneInformacionDetallada = (destino) => {
    return (
      destino.descripcion && destino.descripcion.trim() !== '' ||
      (destino.itinerario && destino.itinerario.length > 0) ||
      (destino.serviciosIncluidos && destino.serviciosIncluidos.length > 0) ||
      (destino.recomendaciones && destino.recomendaciones.length > 0)
    );
  };

const sliderSettings = {
  dots: true,
  infinite: true,
  speed: 500,
    slidesToShow: 2,
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 4000,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  };

  return (
    <section id="destinos" className="py-16 bg-[#fffaf3]">
      <div className="max-w-6xl mx-auto px-4">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-[#B49A56] mb-4">
            Destinos Populares
          </h2>
          <p className="text-gray-600 text-lg max-w-2xl mx-auto">
            Descubrí nuestros destinos más solicitados y planificá tu próxima aventura
          </p>
        </div>

        <div className="slider-container">
        <Slider {...sliderSettings}>
            {destinosPopulares.map((destino, index) => {
              const handleCardClick = () => {
                navigate(`/destinos/${destino.slug}`);
                setTimeout(() => window.scrollTo(0, 0), 100);
              };

              return (
                <div key={destino.slug} className="px-2">
                  <div className="bg-white rounded-lg shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden group w-full max-w-md mx-auto">
                    <div 
                      className="relative cursor-pointer" 
                      onClick={handleCardClick}
                    >
                      <ImageWithFallback
                        src={destino.imagen}
                        alt={`${destino.ciudad}, ${destino.pais}`}
                        className="w-full h-56 object-cover group-hover:scale-105 transition-transform duration-300"
                        fallbackLogo={true}
                        fallbackText={`${destino.ciudad}, ${destino.pais}`}
                      />
                      <div className="absolute top-2 right-2 bg-[#B49A56] text-white px-2 py-1 rounded text-xs font-medium">
                        {destino.noches} noches
                      </div>
                    </div>

                    <div className="px-4 sm:px-5 py-4 sm:py-6">
                      <div className="mb-2">
                        <div className="flex items-start justify-between gap-3 mb-1">
                          <div 
                            className="flex-1 min-w-0 pr-2 cursor-pointer hover:text-[#B49A56] transition-colors"
                            onClick={handleCardClick}
                          >
                            <h3 className="text-base sm:text-lg font-bold text-gray-800 group-hover:text-[#B49A56] transition-colors break-words leading-tight">
                              {destino.ciudad}
                            </h3>
                          </div>
                          <div className="flex items-center gap-2 flex-shrink-0 pt-0.5">
                            {tieneInformacionDetallada(destino) && (
                              <button
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleCardClick();
                                }}
                                className="text-[#B49A56] hover:text-[#9c8448] transition-colors flex-shrink-0 bg-transparent border-none cursor-pointer p-0"
                                title="Ver detalle"
                                aria-label="Ver detalle del destino"
                              >
                                <FaEye className="text-base sm:text-lg" />
                              </button>
                            )}
                            <a
                              href={`https://wa.me/5492616388375?text=${generarMensajeWhatsApp(destino)}`}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="text-green-600 hover:text-green-700 transition-colors flex-shrink-0"
                              title="Consultar por WhatsApp"
                              onClick={(e) => e.stopPropagation()}
                            >
                              <FaWhatsapp className="text-base sm:text-lg" />
                            </a>
                          </div>
                        </div>
                        <p className="text-gray-600 text-sm">{destino.pais}</p>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </Slider>
          </div>

        <div className="text-center mt-6">
          <Link
            to="/destinos"
            className="inline-flex items-center gap-2 bg-[#B49A56] text-white px-8 py-3 rounded-lg hover:bg-[#9c8448] transition-colors font-medium"
          >
            Ver todos los destinos
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
            </svg>
          </Link>
        </div>
      </div>
    </section>
  );
}